import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Util from 'utility';
import { __ } from 'locale';

function DialogNewMeal({ selectedHour, selectedMinute, onAddMeal }) {
    const data = useSelector(state => state);
    const { globals } = data;

    const mealsAreEditable = (() => {
        if(typeof data.lectureTaskData !== 'object') return true;
        const taskData = data.lectureTaskData;
        if(!taskData?.lecture_data) return true;
        const mealsAreEmpty = taskData.lecture_data.meal_types.every(mt => mt.type === "0");
        return mealsAreEmpty;
    })();

    const [type, setType] = useState(mealsAreEditable ? 'meal' : 'drink_regime');
    const [mealId, setMealId] = useState(1);
    const [hour, setHour] = useState(selectedHour);
    const [minute, setMinute] = useState(selectedMinute);
    const [activityTitle, setActivityTitle] = useState('');
    const [activityLength, setActivityLength] = useState(0);

    const hasGastro = Util.userHasPurchased('ZOF_GASTRO');
    const mealTypes = Object.keys(globals.mealTypes)
        .filter(id => {
            const t = globals.mealTypes[id];
            return (hasGastro || !t.gastro_only) && !t.is_drink_regime;
        })
        .map(id => <option value={id} key={id}>{globals.mealTypes[id].title}</option>);

    const lang = Util.getLang();

    let submitTitle, options, tabs;
    if(!mealsAreEditable) {
        tabs = <a className={type == 'drink_regime' ? 'active' : ''} onClick={() => setType('drink_regime')}>Pitný režim</a>;
        options = null;
        submitTitle = lang == 'sk' ? 'Pridať pitný režim' : 'Přidat pitný režim';
    } else if(type == 'drink_regime') {
        tabs = <>
            <a className={type == 'meal' ? 'active' : ''} onClick={() => setType('meal')}>Chod</a>
            <a className="active" onClick={() => setType('drink_regime')}>Pitný režim</a>
            <a className={type == 'activity' ? 'active' : ''} onClick={() => setType('activity')}>Aktivitu</a>
        </>;
        options = null;
        submitTitle = lang == 'sk' ? 'Pridať pitný režim' : 'Přidat pitný režim';
    } else if(type == 'activity') {
        tabs = <>
            <a className={type == 'meal' ? 'active' : ''} onClick={() => setType('meal')}>Chod</a>
            <a className={type == 'drink_regime' ? 'active' : ''} onClick={() => setType('drink_regime')}>Pitný režim</a>
            <a className="active" onClick={() => setType('activity')}>Aktivitu</a>
        </>;
        options = <>
            <tr><th>Popis:</th><td><input type="text" name="activityTitle" value={activityTitle} onChange={e => setActivityTitle(e.target.value)} /></td></tr>
            <tr><th>Délka:</th><td><input type="number" name="activityLength" value={activityLength} onChange={e => setActivityLength(e.target.value)} style={{display:'inline',width:'6em'}} /> minut</td></tr>
        </>;
        submitTitle = lang == 'sk' ? 'Pridať aktivitu' : 'Přidat aktivitu';
    } else {
        tabs = <>
            <a className="active" onClick={() => setType('meal')}>Chod</a>
            <a className={type == 'drink_regime' ? 'active' : ''} onClick={() => setType('drink_regime')}>Pitný režim</a>
            <a className={type == 'activity' ? 'active' : ''} onClick={() => setType('activity')}>Aktivitu</a>
        </>;
        options = <tr><th>Chod:</th><td><select name="mealId" onChange={e => setMealId(e.target.value)}>{mealTypes}</select></td></tr>;
        submitTitle = lang == 'sk' ? 'Pridať chod' : 'Přidat chod';
    }

    const handleAdd = () => onAddMeal({ type, mealId, hour, minute, activityTitle, activityLength, mealsAreEditable });

    return (
        <table className="w-full">
            <tbody>
                <tr>
                    <th>{__('Přidat')}:</th>
                    <td className="[&>a]:inline-block [&>a]:py-[0.4em] [&>a]:px-[0.9em] [&>a]:no-underline [&>a]:text-[#26AA52] [&>a]:rounded-lg [&>a]:border [&>a]:border-transparent [&>a:hover]:bg-[#f0faf4] [&>a.active]:font-semibold [&>a.active]:bg-[#e9f5e5] [&>a.active]:text-[#1a7a38] [&>a.active]:border-[#c6e6d0] [&>a:not(:first-child)]:ml-[0.4em] [&>a]:text-sm [&>a]:cursor-pointer [&>a]:transition-colors">{tabs}</td>
                </tr>
                <tr>
                    <th>Čas:</th>
                    <td className="flex items-center gap-1">
                        <select name="hour" defaultValue={hour} onChange={e => setHour(e.target.value)}>
                            {[...Array(24).keys()].map(n => <option value={n} key={n}>{n < 10 ? '0' + n : n}</option>)}
                        </select>
                        <span className="text-slate-400 font-medium">:</span>
                        <select name="minute" defaultValue={minute} onChange={e => setMinute(e.target.value)}>
                            {[0,5,10,15,20,25,30,35,40,45,50,55].map(n => <option value={n} key={n}>{n < 10 ? '0' + n : n}</option>)}
                        </select>
                    </td>
                </tr>
                {options}
                <tr><th></th><td><button className="mt-1 bg-[#26AA52] text-white text-sm font-semibold py-[0.55em] px-[1.4em] rounded-xl cursor-pointer border-none hover:bg-[#2bbf5c] transition-colors shadow-sm" onClick={handleAdd}>{submitTitle}</button></td></tr>
            </tbody>
        </table>
    );
}

export default DialogNewMeal;
